import React from 'react';
var Textarea = function (props) {
    var id = props.id, isValid = props.isValid, rows = props.rows, readOnly = props.readOnly, required = props.required, _a = props.value, value = _a === void 0 ? '' : _a, onChange = props.onChange;
    return (React.createElement("textarea", { className: "form-control" + (isValid ? '' : ' is-invalid'), id: id, rows: rows, cols: 40, readOnly: readOnly, required: required, defaultValue: value, wrap: "soft", onChange: onChange }));
};
export default React.memo(Textarea);
